/* eslint-disable max-len */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from './translate';

const StatusLabel = ({ t, status, showContainer }) => {
  const containerClass = useMemo(() => {
    if (showContainer) {
      switch (status) {
        case 'approved':
        case 'done':
          return 'approve-container';
        case 'rejected':
          return 'rejected-container';
        default:
          return 'pending-container';
      }
    }
    return '';
  }, [status]);

  const wrapperClass = useMemo(() => {
    switch (status) {
      case 'approved':
      case 'done':
        return 'icon-done-wrapper ';
      case 'rejected':
        return 'icon-rejected-wrapper';
      default:
        return 'icon-wrapper';
    }
  }, [status]);

  const statusClass = useMemo(() => {
    switch (status) {
      case 'approved':
      case 'done':
        return 'status-done';
      case 'rejected':
        return 'status-rejected';
      default:
        return 'status';
    }
  }, [status]);
  return (
    <div
      className={`row statusLabel ${
        showContainer ? `containerStatusWrapper ${containerClass}` : ''
      }`}
    >
      <div className="col-1 column-icon-wrapper">
        <div className={wrapperClass}>
          {status === 'pending' && (
            <svg
              width="20"
              height="20"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.666504 7.00033C0.666504 3.50813 3.50764 0.666992 6.99984 0.666992C10.492 0.666992 13.3332 3.50813 13.3332 7.00033C13.3332 10.4925 10.492 13.3337 6.99984 13.3337C3.50764 13.3337 0.666504 10.4925 0.666504 7.00033ZM2.01409 7.00043C2.01409 9.74965 4.25083 11.9861 6.99993 11.9861C9.74902 11.9861 11.9858 9.74965 11.9858 7.00043C11.9858 4.2512 9.74902 2.01472 6.99993 2.01472C4.25083 2.01472 2.01409 4.2512 2.01409 7.00043Z"
                fill="white"
              />
              <path
                d="M9.90962 6.61243H6.93731V3.45141C6.93731 3.1854 6.69347 2.96973 6.39272 2.96973C6.09198 2.96973 5.84814 3.1854 5.84814 3.45141V7.09411C5.84814 7.36012 6.09198 7.57579 6.39272 7.57579H9.90962C10.2104 7.57579 10.4542 7.36012 10.4542 7.09411C10.4542 6.8281 10.2104 6.61243 9.90962 6.61243Z"
                fill="white"
              />
            </svg>
          )}
          {(status === 'done' || status === 'approved') && (
            <svg
              width="20"
              height="19"
              viewBox="0 0 11 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.21211 8.82662C4.10711 8.93791 3.96385 9 3.81503 9C3.66622 9 3.52296 8.93791 3.41796 8.82662L0.246821 5.48465C-0.0822738 5.13789 -0.0822738 4.57558 0.246821 4.22947L0.643895 3.81096C0.973093 3.4642 1.50612 3.4642 1.83522 3.81096L3.81503 5.8972L9.16478 0.260075C9.49398 -0.0866916 10.0275 -0.0866916 10.3561 0.260075L10.7532 0.678579C11.0823 1.02535 11.0823 1.58754 10.7532 1.93377L4.21211 8.82662Z"
                fill="white"
              />
            </svg>
          )}
          {status === 'rejected' && (
            <svg
              width="17"
              height="17"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.09334 5.33368L10.3932 2.0338C10.7578 1.66919 10.7578 1.07808 10.3932 0.714051L9.9533 0.274135C9.58858 -0.0905809 8.99747 -0.0905809 8.63344 0.274135L5.33368 3.5739L2.0338 0.273452C1.66919 -0.0911506 1.07808 -0.0911506 0.714051 0.273452L0.273452 0.713367C-0.0911506 1.07808 -0.0911506 1.66919 0.273452 2.03323L3.5739 5.33368L0.274135 8.63344C-0.0905809 8.99816 -0.0905809 9.58927 0.274135 9.9533L0.714051 10.3932C1.07865 10.7578 1.66976 10.7578 2.0338 10.3932L5.33368 7.09334L8.63344 10.3932C8.99816 10.7578 9.58927 10.7578 9.9533 10.3932L10.3932 9.9533C10.7578 9.58858 10.7578 8.99747 10.3932 8.63344L7.09334 5.33368Z"
                fill="white"
              />
            </svg>
          )}
        </div>
      </div>
      <div className="col-8 status-wrapper">
        <span className={statusClass}>{t(`status.${status}`)}</span>
      </div>
    </div>
  );
};

StatusLabel.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  showContainer: PropTypes.bool,
};

StatusLabel.defaultProps = {
  status: 'pending',
  showContainer: false,
};

export default translate(StatusLabel);
